<template>
  <inertia-link as="button" v-bind="$props" class="Btn">
    <span class="Btn__text">
      <slot />
    </span>
  </inertia-link>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "~@sass/components/_Btn.scss";
</style>
